var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OktaAuth } from "@okta/okta-auth-js";
import { setHttpOnlyRefreshTokens } from "../graphql/mutations/set-http-only-refresh-token";
var OKTA_TOKEN_STORAGE = "okta-token-storage";
var AuthClient = /** @class */ (function () {
    /**
     * The Singleton's constructor should always be private to prevent direct
     * construction calls with the `new` operator.
     */
    function AuthClient(_a) {
        var config = _a.config, _b = _a.env, env = _b === void 0 ? "prod" : _b;
        this.config = config;
        this.client = new OktaAuth(config);
        this.env = env;
        Object.freeze(this);
    }
    /**
     * The static method that controls the access to the singleton instance.
     *
     * This implementation let you subclass the Singleton class while keeping
     * just one instance of each subclass around.
     */
    AuthClient.getInstance = function (_a) {
        var config = _a.config, env = _a.env;
        if (!AuthClient.instance) {
            AuthClient.instance = new AuthClient({ config: config, env: env });
        }
        return AuthClient.instance;
    };
    /**
     * A wrapper for OktaAuth's static webauthn.buildCredentialCreationOptions method
     */
    AuthClient.buildCredentialCreationOptions = function (enrollResponse) {
        //@ts-ignore okta doesn't export this utility method properly, so we have to ts-ignore it
        return OktaAuth.webauthn.buildCredentialCreationOptions(enrollResponse);
    };
    /**
     * A wrapper for OktaAuth's static webauthn.getAttestation method
     */
    AuthClient.getAttestation = function (credential) {
        //@ts-ignore okta doesn't export this utility method properly, so we have to ts-ignore it
        return OktaAuth.webauthn.getAttestation(credential);
    };
    AuthClient.prototype.start = function () {
        this.client.start();
    };
    AuthClient.prototype.stop = function () {
        this.client.stop();
    };
    AuthClient.prototype.getTokens = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.tokenManager.getTokens()];
            });
        });
    };
    AuthClient.prototype.getTokenRule = function (token) {
        var _a;
        if (!token) {
            return undefined;
        }
        return ((_a = token === null || token === void 0 ? void 0 : token.scopes) === null || _a === void 0 ? void 0 : _a.includes("pii")) ? "default" : "partial";
    };
    AuthClient.prototype.getAuthorizationLevel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTokens()];
                    case 1:
                        accessToken = (_a.sent()).accessToken;
                        if (accessToken === null || accessToken === void 0 ? void 0 : accessToken.scopes.includes("pii")) {
                            return [2 /*return*/, "full"];
                        }
                        if (accessToken === null || accessToken === void 0 ? void 0 : accessToken.scopes.length) {
                            return [2 /*return*/, "partial"];
                        }
                        return [2 /*return*/, "anon"];
                }
            });
        });
    };
    AuthClient.prototype.getAccessToken = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getTokens()];
                    case 1: return [2 /*return*/, (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.accessToken];
                }
            });
        });
    };
    AuthClient.prototype.getRefreshToken = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getTokens()];
                    case 1: return [2 /*return*/, (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.refreshToken];
                }
            });
        });
    };
    AuthClient.prototype.getAuthState = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = {};
                        return [4 /*yield*/, this.client.isAuthenticated({
                                onExpiredToken: "none"
                            })];
                    case 1:
                        _a.isAuthenticated = _b.sent();
                        return [4 /*yield*/, this.getAuthorizationLevel()];
                    case 2: return [2 /*return*/, (_a.authorizationLevel = _b.sent(),
                            _a)];
                }
            });
        });
    };
    AuthClient.prototype.setTokens = function (tokens) {
        var refreshToken = tokens.refreshToken;
        if (refreshToken) {
            // In Okta, refreshToken's expiry is different than accessToken's expiry. But when we get it back from Okta,
            // it'sexpiry is the same as accessToken. That's because the SDK doesn't pay attention
            // to refreshToken's expiry. Therefore, we change refreshToken's expiry to match Okta for consisnecy with lll-ref-full cookie.
            refreshToken.expiresAt = this.getRefreshTokenExpiry();
        }
        this.client.tokenManager.setTokens(tokens);
    };
    AuthClient.prototype.getRefreshTokenExpiry = function (ruleName) {
        if (ruleName === void 0) { ruleName = "default"; }
        var lifeTimeMinutesForEnv = AuthClient.refreshTokenWindowMinutes[this.env];
        var lifeTimeMinutes = ruleName === "partial"
            ? lifeTimeMinutesForEnv.partial
            : lifeTimeMinutesForEnv.default;
        var expiry = new Date(new Date().getTime() + lifeTimeMinutes * 60000);
        return Math.round(expiry.getTime() / 1000);
    };
    Object.defineProperty(AuthClient.prototype, "scopes", {
        get: function () {
            return {
                partial: this.config.partialScopes || [],
                default: this.config.scopes || []
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthClient.prototype, "oktaConfig", {
        get: function () {
            return this.config;
        },
        enumerable: false,
        configurable: true
    });
    // Replacing refreshToken's token to "true" since security doesn't want the token value to be exposed
    AuthClient.prototype.censorRefreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokens, refreshToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.tokenManager.getTokens()];
                    case 1:
                        tokens = _a.sent();
                        if (tokens) {
                            refreshToken = __assign(__assign({}, tokens.refreshToken), { refreshToken: true });
                            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(OKTA_TOKEN_STORAGE, JSON.stringify(__assign(__assign({}, tokens), { refreshToken: refreshToken })));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthClient.prototype.getOktaId = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var accessToken;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.client.tokenManager.getTokens()];
                    case 1:
                        accessToken = (_b.sent()).accessToken;
                        return [2 /*return*/, ((_a = accessToken === null || accessToken === void 0 ? void 0 : accessToken.claims) === null || _a === void 0 ? void 0 : _a.uid) || ""];
                }
            });
        });
    };
    AuthClient.prototype.getUserEmail = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var accessToken;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.client.tokenManager.getTokens()];
                    case 1:
                        accessToken = (_b.sent()).accessToken;
                        return [2 /*return*/, ((_a = accessToken === null || accessToken === void 0 ? void 0 : accessToken.claims) === null || _a === void 0 ? void 0 : _a.sub) || ""];
                }
            });
        });
    };
    AuthClient.prototype.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokens, accessToken, refreshToken, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, Promise.all([
                                this.getAccessToken(),
                                this.getRefreshToken()
                            ])];
                    case 1:
                        tokens = _a.sent();
                        accessToken = tokens[0];
                        refreshToken = tokens[1];
                        return [4 /*yield*/, Promise.all([
                                this.client.revokeAccessToken(accessToken),
                                this.client.revokeRefreshToken(refreshToken),
                                setHttpOnlyRefreshTokens({
                                    fullRefreshToken: null,
                                    partialRefreshToken: null
                                })
                            ])];
                    case 2:
                        _a.sent();
                        this.client.tokenManager.clear();
                        return [4 /*yield*/, this.client.session.close()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.log("AuthClient logout error: ", err_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // Hardcoding these values here since there is no public API to use for fetching these values.
    AuthClient.refreshTokenWindowMinutes = {
        alpha: {
            partial: 60,
            default: 45
        },
        beta: {
            partial: 525600,
            default: 129600 // 90 days
        },
        prod: {
            partial: 525600,
            default: 129600 // 90 days
        }
    };
    return AuthClient;
}());
export { AuthClient };
export default AuthClient;
